import daLocale from 'react-intl/locale-data/da';
import momentLocale from 'moment/src/locale/da';

const DEFAULT_LOCAL_STRING = 'da';

export default class LocaleSettings {
    static getDefaultIntlLocale() {
        return daLocale;
    }

    static getDefaultLocaleString() {
        return DEFAULT_LOCAL_STRING;
    }

    static getDefaultMomentLocale() {
        return momentLocale;
    }
}


// WEBPACK FOOTER //
// ./web/src/common/LocaleSettings.js